import ReactSelect from "@common/ReactSelect";
import { useEffect, useState } from "react";
import InsuranceService from "@src/services/InsuranceService";
import { DISCOUNT_TYPE, WITH_RULE_ENGINE } from "@src/config/constant";
import AddonPopupModal from "./AddonPopup";
import { useNavigate } from "react-router";
import SortingPopupModal from "./sortingPopup";
import FullPageLoader from "../../../common/FullPageLoader";
import FinalQuotationPopup from "./FinalQuotationPopup";
import { CREATE_PAGE_INDEX, MAX_DISCOUNT, QUOTATION_SHARE_TYPE, WHATSAPP_WEB_URL, ROLE} from "@src/config/id/constant";
import { updateAddons } from "./functions/addon.fn";
import { toast } from "react-toastify";
import CommonServiceId from "@src/services/CommonServiceId";
import { addCurrencyFormatting, removeCurrencyFormattingId, restrictInvalidNumberKeys, isValidDecimal, roundPercent } from "@src/config/helper";
import { useLanguage } from "@src/context/LanguageContext";




interface Props {
  addonState: any;
  setAddonState: React.Dispatch<React.SetStateAction<any>>;
  requestData: any;
  setRequestData: React.Dispatch<React.SetStateAction<any>>;
  fetchInsurerList: (addon_detail: any,requestData: any) => Promise<any>;
  handleSubmit: (index:number) => void;
  discountType: any;
  setDiscountType:React.Dispatch<React.SetStateAction<any>>;
  customerDiscount:string;
  setCustomerDiscount:React.Dispatch<React.SetStateAction<any>>;
  error:any
  setError:React.Dispatch<React.SetStateAction<any>>;
  fetchAddons:any,
  leadId:number,
  setLeadId:React.Dispatch<React.SetStateAction<any>>
}

const QuotesMobile = (props: Props) => {
    const {
        addonState,
        setAddonState,
        requestData,
        setRequestData,
        fetchInsurerList,
        handleSubmit,
        discountType,
        setDiscountType,
        customerDiscount,
        setCustomerDiscount,
        error,
        setError,
        fetchAddons,
        leadId,
        setLeadId
    } = props
    
    const navigate: any = useNavigate()

    const [partnerList, setPartnerList] = useState<Array<Object>>([])
    const [otherPartner, setOtherPartner] = useState<Array<Object>>([])
    const [showAddonPopup, setshowAddonPopup] = useState(false);
    const [addons, setAddons] = useState<any>([]);
    const [showSorting,setShowSorting] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const [selectedSort, setSelectedSort] = useState("RC");
    const [isShareActive,setIsShareActive] = useState<boolean>(false);
    const [selectedPartners,setSelectedPartners] = useState<any>([]);
    const [showFinalQuotation,setShowFinalQuotation] = useState<boolean>(false);
    const [finalQuotationData,setFinalQuotationData] = useState<any>({});
    const [preAddonState, setPreAddonState] = useState(addonState);
    const {translations} = useLanguage();

    const getEffectiveRuleEngine = (data: any = requestData) =>
        data?.rule_engine || (data?.role_id === ROLE.AGENT ? WITH_RULE_ENGINE : data?.rule_engine);

    const isRuleEngine:boolean = getEffectiveRuleEngine() === WITH_RULE_ENGINE

    useEffect(() => {
        fetchPartner()
    },[])

    useEffect(() => {
        // validation error
        if (error?.customer_discount) return;

        // initial render  blank value
        if (customerDiscount === "" || customerDiscount === null) return;

        const debounce = setTimeout(() => {
            fetchPartner(customerDiscount, discountType?.value);
        }, 500); // debounce time

        return () => clearTimeout(debounce);
    }, [customerDiscount, discountType]);

    const DiscountType = [
        { value: 1, label: `% ${translations?.CREATE_APP?.DISCOUNT}` },
        { value: 2, label: translations?.CREATE_APP?.AMOUNT },

    ];

    const getInsuranceTypeValues = (data: any) => {
        if (Array.isArray(data?.multi_year) && data?.multi_year?.length) {
            return data.multi_year
                .map((item: any) => item?.insurance_type)
                .filter((value: any) => value !== undefined && value !== null && value !== "");
        }

        if (Array.isArray(data?.insurance_type)) {
            return data.insurance_type
                .filter((value: any) => value !== undefined && value !== null && value !== "");
        }

        if (data?.insurance_type !== undefined && data?.insurance_type !== null && data?.insurance_type !== "") {
            return [data.insurance_type];
        }

        return [];
    };


    const getAddonList = async (id:number) => {
        if(id){
            const payload: any = {
                insurance_type: requestData?.insurance_type,
                vehicle_type: requestData?.vehicle_type,
                plate_area_type: requestData?.plate_area_type,
                make_year: requestData?.make,
                total_fmv: requestData?.total_fmv,
                tenure: requestData?.tenure,
                insurer_id:id
            };
            
            const res = await fetchAddons(payload)
            const basic = res?.basic || []
            const special = res?.special || []
            setAddons([...basic, ...special]);
            setshowAddonPopup(true);
        }
    }

    const fetchPartner = async (
        customerDiscount: any = "", 
        disType: any = "",
        sortBy: string = "RC") => 
    {     
        try{
            setLoading(true)
        
            const  customer_discount_per = (disType === DISCOUNT_TYPE.DISCOUNT)? Number(customerDiscount): 0
            const  customer_discount = (disType === DISCOUNT_TYPE.AMOUNT)? Number(customerDiscount): 0

            const updateRequestData = {...requestData};
            updateRequestData.rule_engine = getEffectiveRuleEngine(updateRequestData);
            updateRequestData.customer_discount_per = customer_discount_per;
            updateRequestData.customer_discount = customer_discount;
            // 1 = % discount (customer_discount_per), 2 = amount (customer_discount); stored so Edit / Continue can prefill it
            if (customer_discount_per > 0 || customer_discount > 0) updateRequestData.discount_type = disType;
            else delete updateRequestData.discount_type;
            updateRequestData.sort_by = sortBy
            setRequestData(updateRequestData);

            const result = await fetchInsurerList(updateRequestData.addon_detail,updateRequestData);
            setPartnerList(result.quotation);
            setOtherPartner(result.other);
        }catch(error){
            console.log(error);
        } finally{
            setLoading(false)
        }  

    }

    const onChangeValue = (e: any, name: any) => {
        if(name === 'discount_type') {
            setDiscountType(e);
            setCustomerDiscount(""); // a value typed for the other type must be re-entered (and re-validated)
            // switching type invalidates the previous value's error (e.g. "Max 4 decimals")
            if (error?.customer_discount) {
                const updatedError = structuredClone(error);
                delete updatedError.customer_discount;
                setError(updatedError);
            }
        }else {
            let value = e.target.value;
            const updatedError = structuredClone(error)
            if(discountType?.value===DISCOUNT_TYPE.DISCOUNT && !isValidDecimal(value)){
                updatedError['customer_discount'] = translations?.COMMON_MSG?.MAX_4D
            }
            else if(discountType?.value===DISCOUNT_TYPE.DISCOUNT && value > MAX_DISCOUNT){
                updatedError['customer_discount'] = translations?.CREATE_APP?.MAX_DISCOUNT_ERROR
            }
            else if(updatedError['customer_discount'] && discountType?.value===DISCOUNT_TYPE.DISCOUNT){
                delete updatedError['customer_discount'];
                setError(updatedError)
            }
            setError(updatedError);
            if(discountType?.value===DISCOUNT_TYPE.AMOUNT) value = removeCurrencyFormattingId(value);
            setCustomerDiscount(value);
        } 
    }

    const resetValues = () => {
        setDiscountType('');
        setCustomerDiscount('');
        if (error?.customer_discount) {
            const updatedError = structuredClone(error);
            delete updatedError.customer_discount;
            setError(updatedError);
        }
        fetchPartner("", "", selectedSort);
    }

    const submitAddon = async () => {
      setPreAddonState(addonState)
      const addons:any = await updateAddons(requestData, addonState, setError,translations);
      if(addons?.errors && Object.keys(addons?.errors).length > 0) return;
      const updatedRequestData = {...requestData};
      updatedRequestData.addon_detail = addons;
      setRequestData(updatedRequestData);
      setshowAddonPopup(false)
    }

    const showAddons = async (id:number) => {
        getAddonList(id);
    }

    const applySorting = (sort:string) => {
        setSelectedSort(sort);
        fetchPartner("","",sort);
        setShowSorting(false);
    }

    const handleMultiShare = async () => {
        if(!isShareActive) return setIsShareActive(true)
        if(selectedPartners.length ===0) return toast.error(translations?.CREATE_APP?.SELECT_INSURER);
        shareFinalQuotation();
    }

    
    // same createAgencyLead call as quotation share (lead stays at Quotation Shared 1/1)
    const saveQuotationLead = async (data:any) => {
        const payload = { ...data };
        delete payload.vehicle
        delete payload.sort_by
        if(leadId) payload.lead_id = leadId
        setLoading(true)
        if (payload?.old_plate_area) {
            delete payload?.old_plate_area
        }
        const insuranceTypeList = getInsuranceTypeValues(payload);
        if (insuranceTypeList?.length) {
            payload.multi_year = insuranceTypeList.map((item: number) => ({ insurance_type: item }));
        }
        delete payload.insurance_type

        if (payload) {
            delete payload.bm_id;
        }

        let result = await InsuranceService.createAgencyLeadID(payload)
        if(result?.data?.status!==200) toast.error(result?.data?.message)
        setLoading(false)
        setShowFinalQuotation(false)
        if(result?.data?.data?.leadId) setLeadId(result?.data?.data?.leadId)
        return result;
    }

    const shareQuotation = async (data:any) => {
        const result: any = await saveQuotationLead(data);
        if(result?.data?.status!==200) return;
        let path = result?.data?.data?.pdfPath;
        if (!path) {
            toast.error("Quotation PDF is not ready yet. Please try sharing again in a moment.");
            return;
        }

        // const updatedRequestData = {...requestData};
        // delete updatedRequestData?.insurer_id;
        // delete updatedRequestData?.partner_id;
        // delete updatedRequestData?.share_insurer_ids;
        // delete updatedRequestData?.is_shared;

        path = await CommonServiceId.getShortFileUrl({url:path})
        path = path?.data?.data
        if (!path || typeof path !== 'string') {
            toast.error("Quotation PDF is not ready yet. Please try sharing again in a moment.");
            return;
        }
        const message = `${translations?.CREATE_APP?.DOC_SHARE_MSG}: ${path}`;
        const url = WHATSAPP_WEB_URL + encodeURIComponent(message);
        window.open(url, '_blank', 'noreferrer');
    }

    const showFinalQuotationData = async (quotationData:any) => {
        setSelectedPartners([]);
        setFinalQuotationData({});
        setSelectedPartners([quotationData.insurer_id]);
        setFinalQuotationData(quotationData);
        setShowFinalQuotation(true);
    }

    const shareFinalQuotation = async () => {
        const updateRequest = {...requestData}
        updateRequest.insurer_id = finalQuotationData.insurer_id;
        updateRequest.partner_id = finalQuotationData.partner_id;
        updateRequest.share_insurer_ids = selectedPartners.join(',');
        updateRequest.is_shared = QUOTATION_SHARE_TYPE.QUOTATION_SHARE
        setRequestData(updateRequest);
        shareQuotation(updateRequest);
    }

    const goToNextStep = async () => {
        const updateRequest = {...requestData}
        updateRequest.insurer_id = finalQuotationData.insurer_id;
        updateRequest.partner_id = finalQuotationData.partner_id;
        updateRequest.share_insurer_ids = selectedPartners.join(',') || String(finalQuotationData.insurer_id);

        // store the lead with the selected insurer (same API as quotation share, no WhatsApp)
        const result: any = await saveQuotationLead({ ...updateRequest, is_shared: QUOTATION_SHARE_TYPE.QUOTATION_SHARE });
        if (result?.data?.status !== 200) return; // error toast shown, stay on the popup

        updateRequest.is_shared = QUOTATION_SHARE_TYPE.QUOTATION_SHARE_NOT
        setRequestData(updateRequest);
        setShowFinalQuotation(false);
        handleSubmit(CREATE_PAGE_INDEX.QUOTES);
    }

    return (
        <>
            <FullPageLoader show={loading} />
            <div className="insurance-quotations-outer">
                <h2>{translations?.CREATE_APP?.INS_QUOTATION}</h2>
                <span className="sub-heading p-sm-t">{requestData?.vehicle} ・ {addCurrencyFormatting(requestData.total_fmv)}</span>


{
    otherPartner.length > 0 && partnerList.length > 0 && (
        <>
        <div className="insurance-discount-filter-top">
        
                    <ReactSelect
                        options={DiscountType}
                        placeholder={translations?.CREATE_APP?.DISCOUNT_TYPE}
                        handleChange={(e: any) => onChangeValue(e, 'discount_type')}
                        value={DiscountType.find((option: any) => option.value === discountType?.value) || discountType}
                    />

                    <fieldset className="">
                        <div className="material">
                            <input 
                            id="" type="text" placeholder=" " 
                            name="discount" 
                            value={discountType?.value===DISCOUNT_TYPE.AMOUNT?addCurrencyFormatting(customerDiscount):customerDiscount ?? ""} 
                            className="form-input" onChange={(e) => onChangeValue(e, 'discount')}
                            onKeyDown={(e) => discountType?.value!==DISCOUNT_TYPE.AMOUNT?restrictInvalidNumberKeys(e, ["."]):null}
                            />
                            <label data-label={translations?.CREATE_APP?.CUSTOMER_DISCOUNT}className="form-label"></label>
                            {
                                error?.customer_discount && <span className="error-txt">{error?.customer_discount}</span>
                            }
                        </div>
                    </fieldset>

                    <div className="btn-submit-reset">
                        <button 
                        className="btn-primary btn-apply-search" 
                        onClick={() => fetchPartner(customerDiscount, discountType.value)}
                        disabled={error?.customer_discount?true:false}
                        >{translations?.COMMON_MSG?.APPLY}
                        </button>
                        <button className="btn-reset" onClick={() => resetValues()}>{translations?.COMMON_MSG?.RESET}</button></div>
                </div>
        </>
    )
}

                {Number(requestData?.tenure) > 1 && <div className="p-md-b quotes-info-text">
                    <i className="ic-info-icon1 m-sm-r"></i>
                    <span> {translations?.MULTIYEAR?.FINAKE_PRICE_VARY}</span>
                </div>}

                <div className="find-quatation-heading-sorting">
                    <div className="found-quatation-count-heading">
                        {partnerList.length} {translations?.CREATE_APP?.QUOTATION_FOUND}
                        <span>{translations?.CREATE_APP?.QUOTATION_BASED_MSG}</span>
                    </div>
                    <div className="quatation-sorting-btn-right">
                        <button style={{ cursor: "pointer" }} className="sorting-btn" onClick={() => {navigate('/create-insurance-policy?step=addons')}}>
                            {translations?.CREATE_APP?.ADD_ONS}
                            <span>{Object.keys(addonState).length}</span>
                        </button>
                        <button style={{ cursor: "pointer" }} className="sorting-btn" onClick={() => setShowSorting(true)}>
                            {translations?.COMMON_MSG?.SORT_BY}
                            <i className="ic-sort"></i>
                        </button>
                        <button 
                            className="sorting-btn"
                            style={isShareActive ? { background: '#008CF0', color: '#fff' } : { background: '#fff', color: '#000' }} 
                            onClick={handleMultiShare}
                            disabled={!isRuleEngine}
                        >
                            {translations?.COMMON_MSG?.SHARE}
                            <i className="ic-share"></i>
                        </button>
                        {
                            isShareActive &&
                            <button className="sorting-btn" onClick={() => {setIsShareActive(false);setSelectedPartners([])}}>
                                X
                            </button>
                        }
                    </div>
                </div>
                <div className="quatation-found-list-outer">
                    {
                        partnerList?.length ? partnerList?.map((item: any, index:number) => {
                            const className = item?.is_disable ? 'disabled-ul' : requestData?.insurer_id === item?.insurer_id ? 'active-ul' : '';
                            return (
                                <div className={`quatation-list-detail ${className}`} key={index}>
                                    <ul>
                                        {
                                            isShareActive &&
                                            <li className="share-checkbox">
                                                <div className="custom-control custom-checkbox">
                                                    <input id={`basic_${item.insurer_id}`} type="checkbox" className="custom-control-input"
                                                    checked={selectedPartners.includes(String(item.insurer_id))}
                                                    onChange={(e) => {
                                                        const id = String(item.insurer_id);
                                                        if (e.target.checked) {
                                                            // add
                                                            setSelectedPartners([...selectedPartners, id]);
                                                        } else {
                                                            // remove
                                                            setSelectedPartners(
                                                                selectedPartners.filter((value: string) => value !== id)
                                                            );
                                                        }
                                                    }}/>
                                                    <label className="custom-control-label" htmlFor={`basic_${item.insurer_id}`}></label>
                                                </div>
                                            </li>
                                        }
                                        <li>
                                            <div className="insurance-patner-logo">
                                                <img src={item.logo} className="" />
                                            </div>
                                            <label className="patner-name">{item.insurer_name}</label>
                                        </li>
                                     

                                        <li>
                                            <label className="patner-name-Premium-Amount t-right"> Premium Amount</label>
                                            <span className="txt-highlight t-right">{addCurrencyFormatting(item.final_premium)}</span>
                                               {
                                              item?.customer_discount_per>0 && 
                                        <div className="discount-offer-txt">
                                            <label className="error-txt">Off {roundPercent(item.customer_discount_per)} %</label>
                                            <span className="txt-highlight discount-cross-word-line">{addCurrencyFormatting(item.final_premium_nodiscount)}</span>
                                        </div>
                                        }
                                        </li>
                                        <li className="br-top-m">
                                            <label>{translations?.CREATE_APP?.COMMISSION_EARNED}</label>
                                            <span>{addCurrencyFormatting(item.final_commision)}</span>
                                        </li>
                                        <li>
                                            <label>{translations?.CREATE_APP?.POINTS_EARNED}</label>
                                            <span>{addCurrencyFormatting(item.final_point)}</span>
                                        </li>
                                        <li>
                                            <div className="insurance-quote-btn-right">
                                                <button style={{ cursor: "pointer" }} className="btn-line m-sm-r" onClick={() => {showAddons(item.insurer_id);}}>
                                                    {translations?.CREATE_APP?.ADD_ONS}
                                                </button> <button style={{ cursor: "pointer" }} onClick={() => showFinalQuotationData(item)} className="btn-primary m-sm-l">
                                                    {translations?.CREATE_APP?.FINAL_QUOTATION}
                                                </button>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            )
                        }): <div className="no-data-found">{translations?.COMMON_MSG?.NO_DATA_FOUND}</div>
                    }

                </div>

                <div className="find-quatation-heading-sorting">
                    <div className="found-quatation-count-heading">
                         {translations?.CREATE_APP?.EXPLORE} {otherPartner.length} {translations?.CREATE_APP?.OTHERS_QUOTATIONS}
                        <span>{translations?.CREATE_APP?.OTHERS_QUOTATIONS_MSG}</span>
                    </div>

                </div>

                <div className="quatation-found-list-outer">
                    {
                        otherPartner.length ? otherPartner.map((item: any, index:number) => {
                            return (
                                <div className="quatation-list-detail" key={index}>
                                    <ul>
                                       {
                                            isShareActive &&
                                             <li className="share-checkbox">
                                                <div className="custom-control custom-checkbox">
                                                    <input id={`basic_${item.insurer_id}`} type="checkbox" className="custom-control-input"
                                                    checked={selectedPartners.includes(String(item.insurer_id))}
                                                    onChange={(e) => {
                                                        const id = String(item.insurer_id);
                                                        if (e.target.checked) {
                                                            // add
                                                            setSelectedPartners([...selectedPartners, id]);
                                                        } else {
                                                            // remove
                                                            setSelectedPartners(
                                                                selectedPartners.filter((value: string) => value !== id)
                                                            );
                                                        }
                                                    }}/>
                                                    <label className="custom-control-label" htmlFor={`basic_${item.insurer_id}`}></label>
                                                </div>
                                            </li>
                                        }
                                        <li>
                                            <div className="insurance-patner-logo">
                                                <img src={item.logo} className="" />
                                            </div>
                                             <label className="patner-name">{item.insurer_name}</label>
                                      
                                        </li>
                                      
                                        <li>
                                            <label className="patner-name-Premium-Amount t-right"> Premium Amount</label>
                                            <span className="txt-highlight t-right">{addCurrencyFormatting(item.final_premium)}</span>
                                                    {
                                              item?.customer_discount_per>0 && 
                                        <div className="discount-offer-txt">
                                            <label className="error-txt">Off {roundPercent(item.customer_discount_per)} %</label>
                                            <span className="txt-highlight discount-cross-word-line">{addCurrencyFormatting(item.final_premium_nodiscount)}</span>
                                        </div>
                                        }
                                        </li>
                                          <li className="br-top-m">
                                            <label>{translations?.CREATE_APP?.COMMISSION_EARNED}</label>
                                            <span>{addCurrencyFormatting(item.final_commision)}</span>
                                        </li>
                                        <li>
                                            <label>{translations?.CREATE_APP?.POINTS_EARNED}</label>
                                            <span>{addCurrencyFormatting(item.final_point)}</span>
                                        </li>
                                        <li>
                                            <div className="insurance-quote-btn-right">
                                                <button style={{ cursor: "pointer" }} className="btn-line m-sm-r" onClick={() => {showAddons(item.insurer_id);}}>
                                                    {translations?.CREATE_APP?.ADD_ONS}
                                                </button> <button style={{ cursor: "pointer" }} className="btn-primary m-sm-l" onClick={() => showFinalQuotationData(item)}>
                                                    {translations?.CREATE_APP?.FINAL_QUOTATION}
                                                </button>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            )
                        }):<div className="no-data-found">
                           <span>{translations?.COMMON_MSG?.NO_DATA_FOUND}</span>
                        </div>
                    }
                </div>
            </div>
            {
                showAddonPopup && <AddonPopupModal show = {showAddonPopup} handleClose={() => { setshowAddonPopup(false); setAddonState(preAddonState)}} 
                onConfirm={submitAddon} 
                basicAddons={addons}
                addonState={addonState}
                setAddonState={setAddonState}
                requestData={requestData}
                error={error}
                setError={setError}
                />
            }
            {
                showSorting && <SortingPopupModal show = {showSorting} handleClose={() => { setShowSorting(false)}} 
                onConfirm={(selectedValue) => {
                    applySorting(selectedValue);
                }}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
                />
            }
            {
                showFinalQuotation && <FinalQuotationPopup show = {showFinalQuotation} handleClose={() => { setShowFinalQuotation(false)}}
                onConfirm={shareFinalQuotation} 
                goToNextStep={goToNextStep}
                finalQuotationData={finalQuotationData}
                isRuleEngine ={isRuleEngine}
                requestData = {requestData}
                />
            }
        </>
    )

}
export default QuotesMobile
